export default __webpack_public_path__ + "static/Hatton-Light-d47d6d5feb8604b24e6b562d1a7b5ed0.woff";